import InvalidLink from './InvalidLink';

export default InvalidLink;
